"use client";

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BasicTable from "../../../Components/Table/Material";
import useApi from "../../../Hooks/useApi";
import { usePagination } from "../../../Hooks/usePagination";

import { handleApiError } from "../../../Helpers/ErrorHandler";
import Common from "../../../Components/Layouts/Common.js";
import ButtonToolbar from "../../Shared/ButtonToolbar.js";
import showToast from "../../../Helpers/toast.js";
import ConfirmModal from "../../../Components/Modal/ConfirmModal.js";

const ActionButtonPanel = ({ row, onDelete }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className="inline-flex flex-wrap gap-2 justify-center text-xs">
      {row.status === "COMPLETED" ? (
        <Link
          to={`/create-survey-questionnaire`}
          state={{
            name: row.name,
            id: row.id,
            isTemplate: true,
          }}
        >
          <button
            className={`bg-[#37a45be6] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
          >
            Use Template
          </button>
        </Link>
      ) : (
        <Link
          to={`/create-survey-questionnaire`}
          state={{ name: row.name, id: row.id }}
        >
          <button
            className={`bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
          >
            Complete Draft
          </button>
        </Link>
      )}

      <Link
        to={"/view-survey-questionnaire"}
        state={{ id: row.id, viewType: "view" }}
      >
        <button
          className={`bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
        >
          View Questionnaire
        </button>
      </Link>
      <Link /* to={`/mapped-survey`} */>
        <button
          disabled={true}
          className={`disabled:bg-gray-400 disabled:cursor-not-allowed bg-[#1976d2] border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
        >
          Mapped Survey
        </button>
      </Link>

      <button
        // onClick={onDelete}
        onClick={() => {
          setModalOpen(true);
        }}
        className={`bg-red-500 border border-gray-300 w-[150px] p-2 text-white rounded-md flex items-center justify-center`}
      >
        Delete Questionnaire
      </button>
      <ConfirmModal
        label={
          <p>
            Are you sure,
            <br /> You want to Delete?
          </p>
        }
        isOpen={isModalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        onConfirm={() => {
          onDelete();
          setModalOpen(false);
        }}
      />
    </div>
  );
};

const SurveyQuestionnaireList = () => {
  const { request } = useApi();
  const navigate = useNavigate();
  const paginateProps = usePagination();

  const [questionnaireData, setQuestionnaireData] = useState();
  const fetchSurveyQuestionnaire = async () => {
    try {
      const response = await request(
        "GET",
        `/v1/survey/questionnaires/list?offset=${paginateProps.page}&limit=${paginateProps.rowsPerPage}`,
        {},
        "survey_service"
      );

      setQuestionnaireData(
        response?.content?.map((item) => ({
          ...item,
          status: item?.status === "COMPLETED" ? item.status : "PENDING",
        }))
      );
      paginateProps.setTotalData(response.totalElements);
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchSurveyQuestionnaire();
  }, [paginateProps.page, paginateProps.rowsPerPage]);

  const columns = [
    {
      id: "name",
      label: "Questionnaire Title",
      minWidth: 170,
    },
    {
      id: "creationDate",
      label: "Date Created",
      minWidth: 100,
      // renderCell: (row) => {
      //   return new Date(row.creationDate)?.toLocaleDateString();
      // },
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },
    {
      id: "action",
      label: "Actions",
      minWidth: 170,
      align: "center",
      renderCell: (row) => {
        return (
          <ActionButtonPanel row={row} onDelete={() => handleDelete(row)} />
        );
      },
    },
  ];

  const handleDelete = async (row) => {
    const questionnaireId = row?.id;

    if (!questionnaireId) return;

    try {
      const response = await request(
        "DELETE",
        `/v1/survey/questionnaires/${questionnaireId}`,
        {},
        "survey_service"
      );
      showToast({ message: response?.message });
      fetchSurveyQuestionnaire();
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <div className=" bg-white  relative h-full">
      <Common headline={" Survey Questionnaire List"}>
        <ButtonToolbar
          title={"Add New Survey Questionnaire"}
          navigateURL={"/select-survey-questionnaire-method"}
        />
        <BasicTable
          columns={columns}
          data={questionnaireData}
          paginateProps={paginateProps}
          maxHeight={15000}
        />
      </Common>
    </div>
  );
};

export default SurveyQuestionnaireList;
